module.exports = __webpack_public_path__ + "static/media/HiDe_transparent.f51bcbb2.png";